import React from 'react';

const Board = ({ board, onMove, turn, playerColor, boardSize, winningPath }) => {
  const N = boardSize || 10;
  
  // Internal coordinate system constants
  const SPACING = 100;
  const HEIGHT = SPACING * Math.sqrt(3) / 2;
  const RADIUS = 30; // Slightly larger radius
  const PADDING = SPACING * 0.5; // Increased padding to prevent clipping

  // Helper to convert visual row/col to Y-Coordinates
  const getCoords = (r, c) => {
    const x = N - r;      // Altitude (Distance from Bottom)
    const y = c;          // Eastward Pull (Distance from Left)
    const z = r - c;      // Westward Pull (Distance from Right)
    return { x, y, z };
  };

  const handleClick = (x, y, z) => {
    onMove(`${x},${y},${z}`);
  };

  const renderPoints = () => {
    const points = [];
    
    for (let r = 0; r <= N; r++) {
      for (let c = 0; c <= r; c++) {
        const { x, y, z } = getCoords(r, c);
        
        // Calculate position
        const xOffset = (N - r) * SPACING / 2;
        const cx = xOffset + c * SPACING;
        const cy = r * HEIGHT;

        const coordKey = `${x},${y},${z}`;
        const color = board[coordKey] || 'transparent';
        const isWinningPiece = winningPath && winningPath.includes(coordKey);
        
        points.push(
          <g key={coordKey} onClick={() => handleClick(x, y, z)} style={{ cursor: 'pointer' }}>
            <title>{`(${x}, ${y}, ${z})`}</title>
            <circle
              cx={cx}
              cy={cy}
              r={RADIUS}
              fill={color === 'transparent' ? '#ddd' : color}
              stroke={isWinningPiece ? "#00FF00" : "black"}
              strokeWidth={isWinningPiece ? "4" : "2"}
            />
          </g>
        );
      }
    }
    return points;
  };

  const renderConnections = () => {
    const lines = [];

    for (let r = 0; r <= N; r++) {
      for (let c = 0; c <= r; c++) {
        const { x, y, z } = getCoords(r, c);
        
        const xOffset = (N - r) * SPACING / 2;
        const cx = xOffset + c * SPACING;
        const cy = r * HEIGHT;

        // Connect to Right neighbor (y+1, z-1)
        if (c < r) {
            const nextX = cx + SPACING;
            const nextY = cy;
            lines.push(<line key={`h-${x}-${y}-${z}`} x1={cx} y1={cy} x2={nextX} y2={nextY} stroke="#999" strokeWidth="2" />);
        }

        // Connect to Bottom-Left neighbor (x-1, z+1)
        if (r < N) {
            const nextRowXOffset = (N - (r + 1)) * SPACING / 2;
            const nextX = nextRowXOffset + c * SPACING;
            const nextY = (r + 1) * HEIGHT;
            lines.push(<line key={`bl-${x}-${y}-${z}`} x1={cx} y1={cy} x2={nextX} y2={nextY} stroke="#999" strokeWidth="2" />);
        }

        // Connect to Bottom-Right neighbor (x-1, y+1)
        if (r < N) {
            const nextRowXOffset = (N - (r + 1)) * SPACING / 2;
            const nextX = nextRowXOffset + (c + 1) * SPACING;
            const nextY = (r + 1) * HEIGHT;
            lines.push(<line key={`br-${x}-${y}-${z}`} x1={cx} y1={cy} x2={nextX} y2={nextY} stroke="#999" strokeWidth="2" />);
        }
      }
    }
    return lines;
  }

  // Calculate viewBox
  const totalWidth = N * SPACING;
  const totalHeight = N * HEIGHT;
  const viewBox = `${-PADDING} ${-PADDING} ${totalWidth + 2*PADDING} ${totalHeight + 2*PADDING}`;

  return (
    <svg 
        viewBox={viewBox} 
        style={{ width: '100%', height: '100%', maxHeight: '100%', maxWidth: '100%', display: 'block' }}
        preserveAspectRatio="xMidYMid meet"
    >
    {renderConnections()}
    {renderPoints()}
    </svg>
  );
};

export default Board;
